import { BulkSpreadsheet, type BulkColumn } from '../shared/BulkSpreadsheet';
import { attributeValueService } from '@kss/api';
import type { AttributeValueCreate } from '@kss/api';
import { loadAttributeOptions } from '../shared/formLoaders';

const columns: BulkColumn<AttributeValueCreate>[] = [
  { key: 'attributeId', header: 'Attribute', required: true, dataType: 'lookup', loadOptions: loadAttributeOptions },
  { key: 'value', header: 'Value', required: true, sample: 'Red' },
];

export default function BulkAttributeValue() {
  return (
    <BulkSpreadsheet<AttributeValueCreate> title="Bulk import attribute values" entityLabel="value" backPath="/panel/attribute-values" columns={columns} module="AttributeValue"
      onImport={async (rows) => {
        const created = await attributeValueService.create(rows);
        return { created: Array.isArray(created) ? created.length : rows.length };
      }}
    />
  );
}
